import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { Sprig } from './FloralDecor';
const points: {
  problem: string;
  result: string;
}[] = [{
  problem: 'Llego sin protocolo claro',
  result: 'Improviso la elección de flores sin un sistema que me respalde'
}, {
  problem: 'No sé diagnosticar rápido',
  result: 'Pierdo los primeros 60 segundos críticos por dudas'
}, {
  problem: 'Falta estructura de cierre',
  result: 'El paciente se va “abierto” y puede reincidir en crisis'
}, {
  problem: 'No tengo seguimiento',
  result: 'Cada sesión es un empezar de cero, sin continuidad'
}, {
  problem: 'Me dreno emocionalmente',
  result: 'Absorbo la energía del paciente sin saber cómo protegerme'
}, {
  problem: 'Pierdo pacientes',
  result: 'No explico bien el valor, no cobro lo que vale, y se van'
}];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-258" data-mp="3nco0ka0k7mft">
      <div className="relative overflow-hidden rounded-3xl border border-brand-rose/30 bg-brand-roseMist/60 p-6 md:p-10" data-id="element-259" data-mp="3nbmpi5jjmzy3">
        <Sprig aria-hidden="true" className="pointer-events-none absolute -right-6 -top-6 h-56 w-32 text-brand-rose/20" data-id="element-260" data-mp="1yz3y31ns6aif" />
        <div className="relative" data-id="element-261" data-mp="1tzhhci8quc4v">
          <h2 className="mb-8 text-center font-display text-2xl font-bold text-brand-green md:text-4xl" data-id="element-262" data-mp="27ti9gt56x0w9">
            ❌ LO QUE PASA SIN EL BOTIQUÍN BACH
          </h2>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-263" data-mp="23trdmb0t3ukv">
            {points.map(point => <li key={point.problem} className="rounded-xl border-l-4 border-brand-rose bg-white p-5" data-id="element-264" data-mp="1g22qd92udwas">
                <p className="mb-1.5 flex items-start gap-2 text-sm font-bold text-brand-green" data-id="element-265" data-mp="1b4kdx8pm8yy1">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-rose" data-id="element-266" data-mp="1p3siyi8gn1a5" />
                  {point.problem}
                </p>
                <p className="pl-6 text-sm leading-relaxed text-brand-muted" data-id="element-267" data-mp="30hnyvt76ve2f">→ {point.result}</p>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-12 rounded-3xl border border-brand-gold/40 bg-brand-parchment p-8 text-center md:p-12" data-id="element-268" data-mp="2vi1i59s5jfov">
        <h3 className="font-display text-2xl font-bold leading-tight text-brand-green md:text-4xl" data-id="element-269" data-mp="1t4vgg8wrk4kz">
          ¿Y si esta fuera la última sesión que trabajas así?
        </h3>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-270" data-mp="2274rr0zuw1zf">
          Imagina que la próxima sesión comienza con claridad total. Con protocolo exacto. Con la seguridad de saber
          qué hacer en cada momento. Sin dudas. Sin improvisación. Sin agotamiento.
        </p>
      </div>
    </Section>;
}